/**
 * エラーチェック結果クラス
 */
export default class EFOcats_error_info {
  /**
   * コンストラクタ
   * @param status
   * @param message
   * @param required
   * @param error_detail
   */
  constructor(status, message, required, error_detail) {
    this.status = status;
    this.message = message;
    this.required = required;
    this.error_detail = error_detail;
  }
}
